import React, { Component } from 'react'
import { YOUTUBE_AUTOCOMPLETE } from '../../../../../../actions/addFeedActions'
import SearchPlace from '../Elements/SearchPlace';
import CheckBoxField from '../Elements/CheckboxField';
import { DEBOUNCE } from '../../../../../../utils';



export default class YtTabs extends Component {
    state = {
        list: [],
        listError: false
    }


    autoComplete = DEBOUNCE(query => {
        const { tab } = this.props
        const searchYoutube = String(query).length;

        if (searchYoutube && ["Play List", "Channel Url", "Shorts"].includes(tab)) {
            try {
                const type = tab == "Play List" ? "playlist" : "channel";

                YOUTUBE_AUTOCOMPLETE(query, type).then(res => {
                    const { responseCode, listItems } = res.data;
                    if (responseCode == 200) {
                        if (listItems && listItems.length > 0) {
                            this.setState({ list: listItems })
                        } else {
                            this.setState({ list: [], listError: true })
                        }

                    }
                }).catch(err=>{
                    this.setState({ list: [], listError: true })
                })
            } catch (error) {
                console.log(error)
            }
        }
        else {
            this.setState({ list: [], listError: true })
        }
    })

    onChangeHandler = (e) => {
        this.setState({ listError: false }, () => {
            this.props.onValueChange(e);
        })
        if (e.target.value && e.target.value.length > 2) {
            this.autoComplete(e.target.value);
        }
    }

    onListClick = (item) => {
        try {
            const { onTextValueChange, tab, onChannelIdChange } = this.props;

            this.setState({ list: [], listError:false }, () => {
                onTextValueChange(tab, tab == "Play List" ? item.snippet.title : item.snippet.channelTitle);
                onChannelIdChange(`${tab == "Play List" ? item.snippet.playlistId : tab == "Shorts" ? item.id.channelId.replace("UC", "UUSH") : item.id.channelId}`,tab)
                document.getElementById(`feedsfield-${tab}`).value = `https://www.youtube.com/${tab == "Play List" ? "playlist?list=" : "channel/"}${tab == "Play List" ? item.snippet.playlistId : tab == "Shorts" ? item.id.channelId.replace("UC", "UUSH") : item.id.channelId}`;
            })
        } catch (error) {

        }
    }



    render() {
        const { tab, onValueChange, checkBox, onLocationValueChange, onCheckBoxChange, errorMsg, error, onLatlanChange, locationKeyword, locationKeywordError } = this.props
        const { list, listError } = this.state;

        return (
            <>
                <div className="row">
                    <div className={`col-md-${tab == "Location" ? '6' : '12'}`}>
                        <div className="form-group">
                            {tab == "Location" ?
                                <SearchPlace onFieldTextChange={onLocationValueChange} onLatlanChange={onLatlanChange} />
                                :
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-${tab == "Shorts" || tab == "Channel Url" ? 'at' : tab == "Play List" ? 'list' : tab == "Keywords" ? "font" : tab == "Location" ? "globe" : ""}`}></i>
                                        </span>
                                    </div>
                                    <input name={`${tab == "Channel Url" ? 'textField' : tab == "Shorts" ? "shorts" : tab == "Play List" ? "playList" : tab == "Keywords" ? "keyword" : ""}`} placeholder={`${tab == "Location" ? "" : "Enter"} ${tab == "Shorts" || tab == "Channel Url" ? "channel name or url" : tab == "Play List" ? "play list url" : tab == "Keywords" ? "keyword" : ""}`} className={`autosearch mycheck form-control ${tab == "Shorts" ? "shorts1" : tab == "Channel Url" ? "channelUrl1" : tab == "Play List" ? "playList1" : tab == "Keywords" ? "keywords1" : ""}`} id={`feedsfield-${tab}`} type="text" onChange={e => this.onChangeHandler(e)} />
                                    {list && list.length ? <div className='handlelist' style={{ display: "block" }}>
                                        <ul className="list-unstyled">
                                            {list.map(item => (
                                                <li data-handle="FdgnlfsSdfgsg" key={item.etag} onClick={() => this.onListClick(item)}>
                                                    <div className="img-section">
                                                        <img src={item.snippet.thumbnails.default.url} />
                                                    </div>
                                                    <div className="content-section"><span>{item.snippet.channelTitle}</span>
                                                        <p>{`https://www.youtube.com/${tab == "Play List" ? "playlist?list=" : "channel/"}${tab == "Play List" ? item.snippet.playlistId : item.id.channelId}`}</p>
                                                    </div>
                                                </li>
                                            ))}

                                        </ul>
                                    </div> : null}
                                </div>
                            }
                            {(listError && !error && !['Location','Keywords'].includes(tab)) ? <span id="feedsfield1error" className="errorMessage required">{`Invalid ${tab != "Play List" ? 'channel name' : 'playlist id'}`}</span> : null}
                            {error ? <span id="feedsfield1error" className="errorMessage required">{errorMsg ? errorMsg : 'This field is required'}</span> : null}
                        </div>
                    </div>
                    {tab == "Location" ?
                        <div className="col-md-6">
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fas fa-font"></i>
                                        </span>
                                    </div>
                                    <input placeholder="Enter keywords" id="" value={locationKeyword} name='locationKeyword' onChange={e => onValueChange(e)} className="form-control" type="text" />
                                    {locationKeywordError ? <span id="feedsfield1error" className="errorMessage required">This field is required</span> : null}
                                </div>
                            </div>
                        </div>
                        : null
                    }
                </div>
                <div className="hideforBSearch">
                    <div className="checkbox-inline">
                        <CheckBoxField isChecked={checkBox} onChangeHandler={(e) => onCheckBoxChange(e.target.checked)} name={"moderation"} id={`checkbox_${tab.replace(/\s/g,'')}`} />
                    </div>
                </div></>
        )
    }
}
